import { AbstractPreset, config } from "./AbstractPreset";

export default class RoundedrectangleNoneCustom extends AbstractPreset {
	getName(): string {
		return 'roundedrectangleNoneCustom';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rounded-rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50,
					"radius": 2,
					"top_left_radius": 2,
					"top_right_radius": 2,
					"bottom_left_radius": 2,
					"bottom_right_radius": 2
				},
			},
			"drillholes": {
				"type": "custom",
				"settings": [
					{
						"x": 100,
						"y": 250,
					},
					{
						"x": 220,
						"y": 150,
					},
					{
						"x": 350,
						"y": 350,
					}
				]
			},
			"cutouts": [],
		};
	}

}
